<template>
  <transition name="fade">
    <div v-if="showModal" class="modalcard centered elevation-1 fixed top-0 left-0 overlay">
      <figure v-bind:class="{ loading: !isLoaded }">
            <v-img
              max-height="500"
              v-show="isLoaded"
              @load="onImgLoad"
              :src="modalImage"
              class="bg-blur"
            >
            </v-img>
            <v-img
              max-height="500"
              v-show="isLoaded"
              @load="onImgLoad"
              :src="modalImage"
              class="primer-image"
              contain
            ></v-img>
          </figure>
          <div class="caption-container" id="captiontext">
            <v-card-title style="justify-content: center;" v-html="card.fullBody"></v-card-title>
          </div>
      <span class="x-button">
        <button
          @click="$emit('close-modal')"
          class="bn w3 h3 fixed top-1 right-1"
          style="color: white; font-size: xx-large; text-shadow: rgb(95 83 51 / 75%) 0px 0px 5px;"
        >
          x
        </button>
      </span>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    card: {
      type: Object,
      default: () => {},
    },
    modalImage: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  computed: {
    blockChildren() {
      return this.body.map((x) => x.children).filter((x) => x.text !== "\n");
    },
  },
  methods: {
    onImgLoad() {
      this.isLoaded = true;
    },
  }
};
</script>

<style>
#captiontext p[style] {
  text-align: center;
  color: #776c6c !important;
  font-size: 12pt !important;
  background-color: transparent !important;
  text-align: left;
}
.overlay {
  background-image: linear-gradient(transparent 50vh, #fff 0, #fff);
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  transition: transform 0.8s cubic-bezier(0, 0.7, 0.4, 1),
  visibility 0s cubic-bezier(0, 0.7, 0.4, 1) 0.8s;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.modalcard {
  height: 80%;
  width: 75%;
  background: white;
  border-radius: 5px;
  overflow: hidden;
}
.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -55%);
}
@media screen and (max-width: 600px){
  .modalcard {
    width: 100%;
    height: 80%;
  }
}
.x-button {
  position: fixed; 
  top: 0; 
  left: 15px;
}
.bg-blur {
  filter: blur(4px);
  -webkit-filter: blur(8px);
  height: 500px;
  z-index: 0;
  opacity: 0.5;
}
.primer-image {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  border: none;
}
.caption-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
}
.caption-container >>> * {
  margin: 0 0;
}
.loading {
  height: 150px;
  width: 150px;
  margin: auto;
  background: transparent
    url("https://miro.medium.com/max/882/1*9EBHIOzhE1XfMYoKz1JcsQ.gif") center
    no-repeat;
}
</style>